import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPencil2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"pencil-2, edit, write, prompt"} maskId="square-filled-radius-0-stroke-1-IconPencil2"><path d="M19.249 10.4566L9.23926 20.4664L2.39062 21.608L3.53223 14.7594L13.542 4.74959L19.249 10.4566Z" fill="currentColor"/><path d="M15.1455 3.14608C16.7214 1.57045 19.2766 1.57045 20.8525 3.14608C22.4284 4.72196 22.4283 7.27711 20.8525 8.85311L19.9561 9.74959L14.249 4.04256L15.1455 3.14608Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPencil2;
